import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IEventsMapTiles, PostalAddress } from '../../models';
import { map, of } from 'rxjs';
import { FeatureCollection, Point } from 'geojson';
import { captureException } from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  private http = inject(HttpClient);

  private configUrl = environment.apiUrl;

  searchLocation(searchQuery: string) {
    if (!searchQuery || searchQuery.length <= 3) {
      return of([]);
    }
    const route = `${this.configUrl}w/a/searchLocation`;

    const params = new HttpParams()
      .set('searchQuery', encodeURIComponent(searchQuery));

    return this.http.get<PostalAddress[]>(route, { params }).pipe(
      map( (locations) => locations?.map( (location) => new PostalAddress(location))),
    );
  }

  createLocation(location: PostalAddress) {
    const route = `${this.configUrl}w/a/createLocation`;

    return this.http.post<PostalAddress>(route, location).pipe(
      map( (location) => new PostalAddress(location)),
    );
  }

  createLocationIfNotExist(searchQuery: string) {
    if (!searchQuery || searchQuery.length <= 3) {
      captureException(`Error in createLocationIfNotExist with searchQuery = ${searchQuery}`);
      return Promise.resolve(undefined);
    }
    const route = `${this.configUrl}w/a/createLocationIfNotExist`;
    const options = {
      limit: 1,
    };

    return this.http.post<PostalAddress>(route, {
      searchQuery,
      options,
    }).pipe(
      map( (location) => new PostalAddress(location)),
    );
  }

  getEventsGeoJSON() {
    const route = `${this.configUrl}eventsGeoJSON`;
    return this.http.get<{
      eventsGeoJSON: FeatureCollection<Point, {
        dateEnd?: Date,
        dateStart: Date,
        imgUrl: string,
        name: string,
        organizerName: string,
        url: string,
      }>,
      eventsMapTiles: IEventsMapTiles,
    }>(route).pipe(
    );
  }


}
